import cx from 'classnames';
import Image from 'components/Image';
import Heading from 'components/Heading';
import Row from 'components/Row';
import Text from 'components/Text';
import * as React from 'react';

import './styles/ChatWelcomeMessage.scss';

type Props = {
  className?: string;
  firstHeader?: React.ReactNode;
  secondHeader?: React.ReactNode;
  hideWelcome?: boolean;
};

class ChatWelcomeMessage extends React.Component<Props, {}> {
  render() {
    const { firstHeader, secondHeader, hideWelcome } = this.props;

    return (
      <div className={cx('ChatWelcomeMessage', this.props.className)}>
        <Image
          className="ChatWelcomeMessage-hero"
          src={require('assets/images/chat-welcome-hero.png')}
        />
        {!hideWelcome && (
          <Heading level="1" levelStyle="2">
            Welcome!
          </Heading>
        )}
        {firstHeader && (
          <Row size="small">
            <Text italic size="medium">
              {firstHeader}
            </Text>
          </Row>
        )}
        {secondHeader && (
          <Row>
            <Text color="graphite" size="medium">
              {secondHeader}
            </Text>
          </Row>
        )}
      </div>
    );
  }
}

export default ChatWelcomeMessage;
